import { useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
function useApi() {
  const context = useContext();
  const query = async (request, variables) => {
    const reqID = `id${Math.random().toString(16).slice(2)}`;
    Logger.debug(`customQuery/request/${reqID}`, request);
    const { data, errors } = await context.app.$vsf.$magento.api.customQuery({ query: request, queryVariables: variables });
    Logger.debug(`customQuery/result/${reqID}`, { data, errors });
    return { data, errors };
  };
  const mutate = async (request, variables) => {
    const reqID = `id${Math.random().toString(16).slice(2)}`;
    Logger.debug(`customQuery/request/${reqID}`, request);
    const { data, errors } = await context.app.$vsf.$magento.api.customMutation({ mutation: request, mutationVariables: variables });
    Logger.debug(`customQuery/result/${reqID}`, { data, errors });
    return { data, errors };
  };
  return { query, mutate };
}
var useApi_default = useApi;
export {
  useApi_default as default,
  useApi
};
